export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-100/70">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-wide mb-3">
            关于
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            关于我们
          </h2>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            <p>
              <strong className="text-foreground-900">窝窝影院</strong>是一个致力于为影迷提供<strong className="text-foreground-900">免费在线观看</strong>服务的影视资源聚合平台。我们深知优质观影体验的价值，因此从建站之初就将"免费、高清、流畅"作为核心理念。
            </p>
            <p>
              平台汇聚了来自全球的海量<strong className="text-foreground-900">免费影视</strong>内容，涵盖电影、电视剧、综艺、动漫、纪录片等全品类资源。无论是院线热映大片、经典口碑佳作，还是当下热门剧集、小众独立电影，用户都能在这里找到并<strong className="text-foreground-900">免费追剧</strong>。
            </p>
            <p>
              技术层面，窝窝影院采用先进的分布式视频加速架构，确保<strong className="text-foreground-900">高清播放</strong>画质的同时实现<strong className="text-foreground-900">不缓冲</strong>的流畅体验。我们坚持<strong className="text-foreground-900">无广告全部免费</strong>的纯净观影环境，让每一位影迷都能专注于内容本身。
            </p>
            <p>
              内容方面，窝窝影院拥有<strong className="text-foreground-900">最新电影电视剧大全</strong>级别的资源覆盖，<strong className="text-foreground-900">每日更新</strong>最新剧集与影片。从热门综艺到冷门佳片，从国产精品到海外大作，我们用心搭建一座连接好内容与观众的桥梁。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}